// @flow

import React, { useEffect, useCallback } from 'react'
import _ from 'lodash'

import { useMessage } from '../../../hooks'
import { MessageService } from '../../../services'

import { CCCalloutBox, CCImageUploader, CCTextInput } from '../../UI'

type Props = {
  message: Object,
  s3Fields: Object,
  s3Options: Object,
  onErrorMessageUpdate: Function
}

const ERROR_MESSAGE = 'No image uploaded'

export function ImageMessage ({
  message: _message,
  s3Fields = {},
  s3Options = {},
  onErrorMessageUpdate
}: Props) {
  const [message,, handlePropertyChange] = useMessage(_message)

  const handleImageUploaded = useCallback((url: string) => {
    MessageService.updateMessage(message.id, {
      ...message,
      image_url: url
    })

    !url ? onErrorMessageUpdate(ERROR_MESSAGE) : onErrorMessageUpdate('')
  }, [message, onErrorMessageUpdate])

  function handleChange (param: any) {
    return (value: any) => {
      const prevValue = _.get(message, param)
      if (value === prevValue) return

      handlePropertyChange(param, false)(value)
    }
  }

  useEffect(() => {
    if (!message.image_url) onErrorMessageUpdate(ERROR_MESSAGE)
  }, [message.image_url, onErrorMessageUpdate])

  return (
    <div>
      <CCImageUploader
        aspectRatio={1.91}
        onUpload={handleImageUploaded}
        currentImageUrl={message.image_url}
        s3PostBackUrl={s3Options.url}
        s3Fields={s3Fields}
      />
      <div className="margin-top-10 text-left">
        <div className="cc-form__field">
          <div className="cc-form__field__label">
            Alternative text
          </div>
          <div className="cc-form__field__input">
            <CCTextInput
              placeholder="Enter alt text"
              onBlur={handleChange('data.imageAltText')}
              onPressEnterKey={handleChange('data.imageAltText')}
              value={message.data.imageAltText}
            />
          </div>
        </div>
        {!message.data.imageAltText && (
          <CCCalloutBox type="info">
            Please fill in the alt text field &#x2014; if empty, the image will be marked as decorative and skipped by screen readers.
          </CCCalloutBox>
        )}
      </div>
    </div>
  )
}
